export const LargeListRowModelTypeName = 'largeList';
export const LARGE_LIST_ROW_MODEL_DEFAULT_RECORDS_LIMIT = 1000;
export type LargeListRowModelType = {
  rowModelType: typeof LargeListRowModelTypeName;
  recordsLimit: number;
};

export const PagingRowModelTypeName = 'paging';
export type PagingListRowModelType = {
  rowModelType: typeof PagingRowModelTypeName;
};

export type TEntityGridRowModelNameTypes =
  | typeof LargeListRowModelTypeName
  | typeof PagingRowModelTypeName;

export type TEntityGridRowModels =
  | LargeListRowModelType
  | PagingListRowModelType;
